//nav-mobile-trigger

var hornstrup = hornstrup || {};

hornstrup.contourCustom = hornstrup.contourCustom || function () {
    var self = this;

    this.init = function (callback) {
        $('.contour').on('focus','input[type=text], textarea, select, input[type=checkbox], input[type=radio]',function(){
            self.specificClass(this,'input--focus','add');
        })

        $('.contour').on('blur','input[type=text], textarea, select, input[type=checkbox], input[type=radio]',function(){
            self.specificClass(this,'input--focus','remove');
            var elementType = $(this).get(0).tagName.toLowerCase();
            var inputType="";
            if(elementType == "input"){
                inputType = $(this).attr('type');
            }

            if(elementType == "select" || elementType == "textarea" || (elementType == "input" && inputType=="text")){
                if($(this).val()!=""){
                    self.specificClass(this,'input--filled','add');
                }
                else{
                    self.specificClass(this,'input--filled','remove');
                }
            }

            if(elementType == "input" && (inputType=="checkbox" || inputType=="radio")){
                var inputName = $(this).attr('name');

                if(inputType=="radio"){

                    self.specificClass(this,'input--filled','add');
                }
                if(inputType=="checkbox"){
                    if($('input[name="'+inputName+'"]:checked').length){
                        self.specificClass(this,'input--filled','add');
                    }else{
                        self.specificClass(this,'input--filled','remove');
                    }
                }
            }



        })

        $('.contour').on('click','input[type=submit]',function(){
            var thisContour = $(this).closest('.contour');
            if($('.field-validation-error',thisContour).length){
                var firstErrorContourField = $('.field-validation-error',thisContour).first().closest('.contourField');
                var navigationHeight = $('#header').outerHeight();

                $('html, body').animate({
                    scrollTop: $(firstErrorContourField).offset().top-navigationHeight
                }, 500, function(){

                    setTimeout(function(){ $('#header').attr('class','nav-moving-down nav-moving'); }, 251);
                });
            }

        });

    }

    this.specificClass = function (element,className,addOrRemove) {
        if(addOrRemove == "remove"){
            $(element).removeClass(className).closest('.contourField').removeClass(className).children('label').removeClass(className);
        }else{
            $(element).addClass(className).closest('.contourField').addClass(className).children('label').addClass(className);
        }

    }





    // public functions:
    return {
        init: init
    };
}();